export default function renderInputLabelProps(isEmpty: boolean) {
  if (isEmpty) {
    return {
      className: "empty-field",
    }
  }
  return undefined
}
